import React from 'react';
import { SITE } from '../../seo/siteMeta';

// WhatsApp green
const WAPP_GREEN = '#25D366';

const WhatsAppButton = () => {
  // Use api.whatsapp.com (recommended over wa.me for tracked attribution)
  const sanitised = (SITE.whatsapp || '').replace(/[^\d]/g, '');
  const href = `https://api.whatsapp.com/send?phone=${sanitised}&text=${encodeURIComponent('Hi H.A.R.P Solutions — I would like to enquire about your services.')}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full shadow-lg shadow-black/40 hover:scale-110 transition-transform"
      style={{ backgroundColor: WAPP_GREEN }}
    >
      {/* Inline WhatsApp glyph keeps it crisp at any size; no extra HTTP request */}
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M16.003 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.55-1.72a12.7 12.7 0 0 0 6.25 1.6h.01c7.07 0 12.79-5.73 12.79-12.8s-5.73-12.68-12.8-12.68zm0 23.3h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.89 1.02 1.04-3.79-.25-.39a10.62 10.62 0 0 1-1.63-5.63c0-5.88 4.78-10.66 10.66-10.66 2.85 0 5.52 1.11 7.54 3.13a10.6 10.6 0 0 1 3.12 7.54c0 5.88-4.78 10.66-10.66 10.66zm5.84-7.99c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.7.16s-.81 1.03-.99 1.24c-.18.21-.36.24-.68.08-.32-.16-1.34-.49-2.55-1.57a9.6 9.6 0 0 1-1.77-2.2c-.18-.32-.02-.49.14-.65.14-.14.32-.36.49-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.61-.51-.52-.7-.53l-.6-.01c-.21 0-.55.08-.84.4s-1.1 1.07-1.1 2.6 1.13 3.02 1.29 3.23c.16.21 2.22 3.39 5.39 4.76.75.32 1.34.51 1.8.66.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.26-.74.26-1.37.18-1.51-.08-.13-.29-.21-.6-.37z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
